// extracted by mini-css-extract-plugin
module.exports = {"DeskUtilizationOverTimePage":"DesksUsageOverTime_DeskUtilizationOverTimePage__2XNYS","cardsContainer":"DesksUsageOverTime_cardsContainer__1v0WD"};